import React from 'react';

/**
 * Horizontal flex row layout primitive.
 * @param {React.HTMLAttributes<HTMLDivElement> & {
 *   gap?: number | string;
 *   align?: string;
 *   justify?: string;
 *   wrap?: boolean;
 *   flex?: number | string;
 *   children?: React.ReactNode;
 * }} props
 */
const Row = ({ gap, align = 'center', justify, wrap, flex, style, children, ...rest }) => (
  <div
    style={{
      display: 'flex',
      alignItems: align,
      ...(justify != null && { justifyContent: justify }),
      ...(gap != null && { gap }),
      ...(wrap && { flexWrap: 'wrap' }),
      ...(flex != null && { flex }),
      ...style,
    }}
    {...rest}
  >
    {children}
  </div>
);

export default Row;
